module.exports = __webpack_public_path__ + "static/media/m0n0wall.6ff8c7bf.jpg";